module.exports = __webpack_public_path__ + "img/ennetix-application-detail-page-alerts-panel4.290b4cfc.png";